const isInputNumber = (input: string): boolean =>
    typeof input !== 'undefined' && !Number.isNaN(Number(input.replace(',', '.')));

export default isInputNumber;
